(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-ann-bar]').forEach(function (bar) {
      var key = 'citera:ann:' + bar.getAttribute('data-ann-key');
      try {
        if (localStorage.getItem(key) === '1') {
          bar.hidden = true;
          return;
        }
      } catch (e) {}
      var close = bar.querySelector('[data-ann-close]');
      if (close) {
        close.addEventListener('click', function () {
          bar.hidden = true;
          try {
            localStorage.setItem(key, '1');
          } catch (e) {}
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    const formatNumber = (value, maximumFractionDigits = 2) =>
      new Intl.NumberFormat('ro-RO', {
        maximumFractionDigits,
        minimumFractionDigits: value % 1 === 0 ? 0 : 1,
      }).format(value);

    document.querySelectorAll('[data-collection-material-calculator]').forEach((calculator) => {
      const typeInput = calculator.querySelector('[data-collection-calc-type]');
      const areaInput = calculator.querySelector('[data-collection-calc-area]');
      const widthInput = calculator.querySelector('[data-collection-calc-width]');
      const heightInput = calculator.querySelector('[data-collection-calc-height]');
      const result = calculator.querySelector('[data-collection-calc-result]');
      const note = calculator.querySelector('[data-collection-calc-note]');
      if (!typeInput || !areaInput || !widthInput || !heightInput || !result || !note) return;

      const read = (input) => Number.parseFloat(String(input.value || '').replace(',', '.')) || 0;
      const update = () => {
        const manualArea = read(areaInput);
        const width = read(widthInput);
        const height = read(heightInput);
        const area = manualArea > 0 ? manualArea : width * height;
        const type = typeInput.value;

        if (area <= 0) {
          result.textContent = 'Introdu suprafața';
          note.textContent =
            type === 'plat'
              ? 'Plat: o pungă de 500 g acoperă aproximativ 0,5 m².'
              : type === 'cret'
                ? 'Creț: consum estimat 6 kg / m²; cutie mare 5 kg / 1000 lei.'
                : 'Bombat: cutie mică 0,09 m²; cutie mare 1 m² / 1000 lei.';
          return;
        }

        if (type === 'plat') {
          const bags = Math.max(1, Math.ceil(area / 0.5));
          result.textContent = `${bags} ${bags === 1 ? 'pungă de 500 g' : 'pungi de 500 g'} pentru ${formatNumber(area)} m²`;
          note.textContent = 'Calculat la aproximativ 0,5 m² / pungă.';
          return;
        }

        if (type === 'cret') {
          const kg = area * 6;
          const smallPacks = Math.max(1, Math.ceil(kg / 0.5));
          const bigPacks = Math.max(1, Math.ceil(kg / 5));
          result.textContent = `${formatNumber(kg)} kg pentru ${formatNumber(area)} m²`;
          note.textContent = `Aprox. ${smallPacks} ${smallPacks === 1 ? 'cutie' : 'cutii'} de 0,5 kg sau ${bigPacks} ${bigPacks === 1 ? 'cutie mare' : 'cutii mari'} de 5 kg (1000 lei / cutie mare).`;
          return;
        }

        const smallBoxes = Math.max(1, Math.ceil(area / 0.09));
        const bigBoxes = Math.floor(area / 1);
        const remainingArea = Math.max(0, area - bigBoxes);
        const remainingSmall = remainingArea > 0 ? Math.ceil(remainingArea / 0.09) : 0;
        result.textContent = `${smallBoxes} ${smallBoxes === 1 ? 'cutie mică' : 'cutii mici'} pentru ${formatNumber(area)} m²`;
        note.textContent =
          bigBoxes > 0
            ? `Variantă mixtă: ${bigBoxes} ${bigBoxes === 1 ? 'cutie mare' : 'cutii mari'}${
                remainingSmall > 0
                  ? ` + ${remainingSmall} ${remainingSmall === 1 ? 'cutie mică' : 'cutii mici'}`
                  : ''
              } (1000 lei / cutie mare).`
            : 'Pentru proiecte mari poți calcula și cu cutie mare de 1 m² / 1000 lei.';
      };

      [typeInput, areaInput, widthInput, heightInput].forEach((input) => input.addEventListener('input', update));
      typeInput.addEventListener('change', update);
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    const openBtn = document.querySelector('[data-zoom-open]');
    const dialog = document.querySelector('[data-lightbox]');
    if (!openBtn || !dialog || typeof dialog.showModal !== 'function') return;
    const lbImg = dialog.querySelector('[data-lightbox-img]');
    const main = document.getElementById('product-media-main');
    const thumbs = Array.from(document.querySelectorAll('[data-thumb]'));
    const urls = thumbs.length
      ? thumbs.map((t) => t.dataset.full)
      : [main ? main.currentSrc || main.src : ''];
    let idx = 0;
    const show = (i) => {
      idx = (i + urls.length) % urls.length;
      lbImg.src = urls[idx];
    };
    const activeIndex = () => {
      const a = thumbs.findIndex((t) => t.getAttribute('aria-pressed') === 'true');
      return a >= 0 ? a : 0;
    };
    openBtn.addEventListener('click', () => {
      show(activeIndex());
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      const closeBtn = dialog.querySelector('[data-lightbox-close]');
      if (closeBtn) closeBtn.focus();
    });
    dialog.querySelector('[data-lightbox-close]').addEventListener('click', () => dialog.close());
    dialog.querySelector('[data-lightbox-prev]')?.addEventListener('click', () => show(idx - 1));
    dialog.querySelector('[data-lightbox-next]')?.addEventListener('click', () => show(idx + 1));
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) dialog.close();
    });
    dialog.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') show(idx - 1);
      if (e.key === 'ArrowRight') show(idx + 1);
    });
    // Return focus to the zoom trigger when the lightbox closes (WCAG 2.4.3).
    dialog.addEventListener('close', () => openBtn.focus());
  })();

  (function () {
    const formatNumber = (value, maximumFractionDigits = 2) =>
      new Intl.NumberFormat('ro-RO', {
        maximumFractionDigits,
        minimumFractionDigits: value % 1 === 0 ? 0 : 1,
      }).format(value);

    document.querySelectorAll('[data-coverage-calculator]').forEach((calculator) => {
      const mode = calculator.dataset.mode || 'kg';
      const rate = Number.parseFloat(calculator.dataset.rate || '6') || 6;
      const packKg = Number.parseFloat(calculator.dataset.packKg || '0.5') || 0.5;
      const bigPackKg = Number.parseFloat(calculator.dataset.bigPackKg || '5') || 5;
      const bigPackPrice = Number.parseFloat(calculator.dataset.bigPackPrice || '0') || 0;
      const unitCoverage = Number.parseFloat(calculator.dataset.unitCoverage || '0') || 0;
      const largeCoverage = Number.parseFloat(calculator.dataset.largeCoverage || '0') || 0;
      const largePrice = Number.parseFloat(calculator.dataset.largePrice || '0') || 0;
      const unitLabel = calculator.dataset.unitLabel || 'unitate';
      const unitLabelPlural = calculator.dataset.unitLabelPlural || unitLabel;
      const areaInput = calculator.querySelector('[data-calc-area]');
      const widthInput = calculator.querySelector('[data-calc-width]');
      const heightInput = calculator.querySelector('[data-calc-height]');
      const result = calculator.querySelector('[data-calc-result]');
      const packs = calculator.querySelector('[data-calc-packs]');
      const large = calculator.querySelector('[data-calc-large]');
      const apply = calculator.querySelector('[data-calc-apply]');
      const applyNote = calculator.querySelector('[data-calc-apply-note]');
      if (!areaInput || !widthInput || !heightInput || !result || !packs) return;

      const unitName = (count, singular, plural) => (count === 1 ? singular : plural);
      const read = (input) => Number.parseFloat(String(input.value || '').replace(',', '.')) || 0;
      const hideApply = () => {
        if (!apply) return;
        apply.hidden = true;
        apply.dataset.qty = '';
        apply.textContent = 'Setează cantitatea recomandată';
        if (applyNote) {
          applyNote.hidden = true;
          applyNote.textContent = '';
        }
      };
      const showApply = (quantity, label) => {
        if (!apply) return;
        apply.hidden = false;
        apply.dataset.qty = String(quantity);
        apply.dataset.label = label;
        apply.textContent = `Setează cantitatea la ${quantity}`;
      };
      const update = () => {
        const manualArea = read(areaInput);
        const width = read(widthInput);
        const height = read(heightInput);
        const area = manualArea > 0 ? manualArea : width * height;

        if (area <= 0) {
          result.textContent = 'Introdu suprafața';
          packs.textContent =
            mode === 'area' && unitCoverage > 0
              ? `${formatNumber(unitCoverage)} m² / ${unitLabel}`
              : `${formatNumber(rate)} kg / m²`;
          if (large) {
            large.hidden = true;
            large.textContent = '';
          }
          hideApply();
          return;
        }

        if (mode === 'area' && unitCoverage > 0) {
          const requiredUnits = Math.max(1, Math.ceil(area / unitCoverage));
          const requiredLabel = unitName(requiredUnits, unitLabel, unitLabelPlural);
          result.textContent = `${requiredUnits} ${unitName(requiredUnits, unitLabel, unitLabelPlural)} pentru ${formatNumber(area)} m²`;
          packs.textContent = `calculat la ${formatNumber(unitCoverage)} m² / ${unitLabel}`;
          showApply(requiredUnits, requiredLabel);

          if (large && largeCoverage > 0) {
            const largeUnits = Math.floor(area / largeCoverage);
            const remainingArea = Math.max(0, area - largeUnits * largeCoverage);
            const remainingSmallUnits = remainingArea > 0 ? Math.ceil(remainingArea / unitCoverage) : 0;
            const largeLabel = largeUnits === 1 ? 'cutie mare' : 'cutii mari';
            const priceText = largePrice > 0 ? `, ${formatNumber(largePrice, 0)} lei / cutie mare` : '';
            large.hidden = false;
            large.textContent =
              largeUnits > 0
                ? `variantă mixtă: ${largeUnits} ${largeLabel}${
                    remainingSmallUnits > 0
                      ? ` + ${remainingSmallUnits} ${unitName(remainingSmallUnits, unitLabel, unitLabelPlural)}`
                      : ''
                  }${priceText}`
                : `pentru proiecte mari: cutie mare de ${formatNumber(largeCoverage)} m²${priceText}`;
          }
          return;
        }

        const requiredKg = area * rate;
        const requiredPacks = Math.max(1, Math.ceil(requiredKg / packKg));
        const requiredBigPacks = Math.max(1, Math.ceil(requiredKg / bigPackKg));
        const packLabel = `${requiredPacks === 1 ? 'cutie' : 'cutii'} de ${formatNumber(packKg)} kg`;
        result.textContent = `${formatNumber(requiredKg)} kg pentru ${formatNumber(area)} m²`;
        packs.textContent = `aprox. ${requiredPacks} ${packLabel}`;
        showApply(requiredPacks, packLabel);
        if (large) {
          const bigPriceText = bigPackPrice > 0 ? ` (${formatNumber(bigPackPrice, 0)} lei / cutie mare)` : '';
          large.hidden = false;
          large.textContent = `sau ${requiredBigPacks} ${
            requiredBigPacks === 1 ? 'cutie mare' : 'cutii mari'
          } de ${formatNumber(bigPackKg)} kg${bigPriceText}`;
        }
      };

      [areaInput, widthInput, heightInput].forEach((input) => input.addEventListener('input', update));
      apply?.addEventListener('click', () => {
        const quantity = Number.parseInt(apply.dataset.qty || '0', 10);
        const label = apply.dataset.label || '';
        const productRoot = calculator.closest('[data-product]');
        const quantityInput = productRoot?.querySelector('input[name="quantity"]');
        if (!quantity || !quantityInput) return;
        quantityInput.value = String(quantity);
        quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        if (applyNote) {
          applyNote.hidden = false;
          applyNote.textContent = `Cantitatea din produs a fost setată la ${quantity}${label ? ` ${label}` : ''}.`;
        }
      });
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-slideshow]').forEach((root) => {
    const track = root.querySelector('[data-slideshow-track]');
    const slides = Array.from(root.querySelectorAll('[data-slideshow-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-slideshow-dot]'));
    if (!track || slides.length < 2) return;

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let current = 0;

    const go = (i, smooth = true) => {
      current = (i + slides.length) % slides.length;
      track.scrollTo({
        left: slides[current].offsetLeft,
        behavior: smooth && !reduce ? 'smooth' : 'auto',
      });
    };

    root.querySelector('[data-slideshow-next]')?.addEventListener('click', () => go(current + 1));
    root.querySelector('[data-slideshow-prev]')?.addEventListener('click', () => go(current - 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => go(i)));

    // Sync dots with the visible slide
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            current = slides.indexOf(e.target);
            dots.forEach((d, i) =>
              d.setAttribute('aria-current', i === current ? 'true' : 'false'),
            );
          }
        });
      },
      { root: track, threshold: 0.6 },
    );
    slides.forEach((s) => io.observe(s));

    // Autoplay (disabled for reduced motion; pauses on hover/focus)
    if (root.dataset.autoplay === 'true' && !reduce) {
      const speed = Math.max(2, parseInt(root.dataset.autoplaySpeed, 10) || 6) * 1000;
      let timer = setInterval(() => go(current + 1), speed);
      const stop = () => {
        clearInterval(timer);
        timer = null;
      };
      const start = () => {
        if (!timer) timer = setInterval(() => go(current + 1), speed);
      };
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
